// Routing module for the auth module. Includes login, signup, and password reset routes.
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { ErrorComponent } from './views/error/error.component';
import { ResetComponent } from './views/reset/reset.component';
import { ForgotComponent } from './views/forgot/forgot.component';
import { SignupEmailComponent } from './views/signup-email/signup-email.component';
import { SignupCodeComponent } from './views/signup-code/signup-code.component';
import { SignupPasswordComponent } from './views/signup-password/signup-password.component';


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },{
    path: 'error',
    component: ErrorComponent
  },{
    path: 'reset',
    component: ResetComponent
  },{
    path: 'forgot',
    component: ForgotComponent
  },{
    path: 'signup/email',
    component: SignupEmailComponent
  },{
    path: 'signup/code',
    component: SignupCodeComponent
  },{
    path: 'signup/password',
    component: SignupPasswordComponent
  },{
    path: 'signup',
    redirectTo: 'signup/email',
    pathMatch: 'full'
  },{
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}